import styled from '@emotion/styled';
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';
import generateCalendar from 'antd/es/calendar/generateCalendar';
import 'antd/es/calendar/style';

const Calendar = generateCalendar(dateFnsGenerateConfig);

export const SadaKCalendar = styled(Calendar)``;
